<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="join container">
        <div class="welcome">
          <span class="imgWrap">
            <img src="../../../assets/images/thanq_logo.png" />
          </span>
          <p>땡큐에 오신것을 환영합니다.</p>
        </div>
        <div class="selectType">
          <label
            class="type"
            for="underAge"
            :class="{ active: underAgeChecked }"
          >
            <h3>수술/시술 상담</h3>
            <input
              type="checkbox"
              id="underAge"
              name="underAge"
              class="hideValue"
              value="underAgeTerms"
              @click="underAgeSelect"
              v-model="underAgeChecked"
            />
          </label>
          <label class="type" for="overAge" :class="{ active: overAgeChecked }">
            <h3>검진/검사/기타</h3>
            <input
              type="checkbox"
              id="overAge"
              name="overAge"
              class="hideValue"
              value="overAgeTerms"
              @click="overAgeSelect"
              v-model="overAgeChecked"
            />
          </label>
        </div>
      </div>
      <div class="btnWrap" :class="{ visible: buttonUp }">
        <button type="button" class="callTerms" @click="nextAuthorized()">
          다음
        </button>
      </div>
    </div>
    <add-popup v-if="checkPopup" :popupSet="popupSet" />
  </div>
</template>

<script>
import AppHeader from "../../../components/AppHeader";
import AppSidebar from "../../../components/AppSidebar";
import AddPopup from "@/components/AddPopup";
import { mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      popupSet: {
        title: "",
        modalImg: "alert_cn.svg",
        content: "",
        confirmBtnText: "확인",
        count: "single",
      },
      transDate: {
        headerName: "예약",
        prevUrl: "/reservation/explain",
      },
      buttonUp: false,
      underAgeChecked: false,
      overAgeChecked: false,
    };
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup,
  },
  computed: {
    ...mapState(["checkPopup"]),
  },
  methods: {
    ...mapMutations(["SET_POPUP"]),
    overAgeSelect() {
      this.overAgeChecked = !this.overAgeChecked;
      if (this.underAgeChecked) {
        this.underAgeChecked = !this.underAgeChecked;
      } else {
        this.buttonUp = !this.buttonUp;
      }
    },
    underAgeSelect() {
      this.underAgeChecked = !this.underAgeChecked;
      if (this.overAgeChecked) {
        this.overAgeChecked = !this.overAgeChecked;
      } else {
        this.buttonUp = !this.buttonUp;
      }
    },
    nextAuthorized() {
      if (!this.buttonUp) {
        this.SET_POPUP(true);
        this.popupSet.content = "예약종류를 선택해주세요";
        return false;
      } else {
        console.log("진입함");
        this.$router.push("/reservation/selectDisease");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
